module.exports = __webpack_public_path__ + "ec4ffcea83ad32691c2a1918479cb312.pdf";